import { Controller } from '@hotwired/stimulus';
export default class extends Controller {
  static values = {
    maxMb: Number,
  };

  connect() {
    console.log('Connect FileSizeController');
    this.element.addEventListener('change', this.checkFileSize.bind(this));
  }

  checkFileSize() {
    console.log('Checking file size');
    if (this.maxMbValue * 1024 * 1024 < this.element.files[0].size) {
      alert(`File too big, please split your file into files smaller than ${this.maxMbValue} MB.`);
      this.element.value = ''; //unselect file
    }
  }
}
